import { EBusinessSolution } from '@aca-new/app/shared/models/enums/business-solution.enum';

/**
 * Resolves the payments business solution label for a dynamic booking menu.
 * @param {string} menuKey - Dynamic booking menu key.
 * @param {string} serviceCategory - Menu service category from the API.
 * @param {boolean} isEmbedInAca - Whether payments is embedded in legacy ACA.
 * @returns {string} Translation key, or the API service category when no mapping exists.
 */
export function getDynamicBusinessSolutionLabel(menuKey: string, serviceCategory: string, isEmbedInAca: boolean): string {
  if (!isEmbedInAca && menuKey.toLowerCase() === EBusinessSolution.SELF_ASSESSMENT) {
    return 'COMMON.TRACEABILITY';
  }

  if (serviceCategory.toLowerCase() === EBusinessSolution.CALLBACKS) {
    return 'DATA_TABLE.SELECT.CALLBACKS';
  }

  return serviceCategory;
}
